
import React, {Component, Fragment} from 'react'
import { connect } from 'react-redux'
import {Button} from 'reactstrap';
import PaymentDialogue from '../../payment/PaymentDialogue';

var saleEndorsementUtils = require('../../../../../utils/domain/externalIntegrations/endorsements/saleEndorsementUtils');
var saleCommonUtility = require('../../../../../utils/domain/sales/saleCommonUtility');
var commonUtility = require('../../../../../utils/domain/commonUtility');
var saleCalculator = require('../../../../../utils/domain/sales/saleCalculator');
var localizationUtils = require('../../../../../utils/domain/localizationUtils');
var constants = require('../../../../../utils/domain/constants');
var saleContextUtil = require('../../../utils/saleContextUtil');
var salePrinter = require('../../../utils/salePrinter');
var viewUtil = require('../../../../../utils/view/viewUtil');
const translator = require('../../../../../utils/translator/translator');

class PayToolbarButton extends Component 
{
    constructor(props)
    {
        super(props);

        this.onPayment = this.onPayment.bind(this);
       
        this.state = {};
        this.state.showPaymentDialogue = false;
    }

    render()
    {
        return (<Fragment>
                    <Button disabled={saleCommonUtility.isSaleHoldByStaff(this.props.saleContext.sale) || this.props.saleContext.sale.isCancelled} 
                                className='btn-action' style={{minHeight:'8vh', minWidth:'33.33%', borderRadius: 0}}
                                onClick={this.onPayment}>
                            {translator.getLabel("pay")}
                    </Button>
                    {this.renderPaymentDialogue()}
                </Fragment>)
    }

    onPayment()
    {
        var error = this.verifySelectedRowsForPayment();
        if (error != null)
        {
            viewUtil.showErrorAlert(error);
            this.state.showPaymentDialogue = false;
            this.setState({});
            return;
        }

        var partialPayableAmount = this.calculatePartialPayableAmount();
        if (partialPayableAmount != null)
        {
            viewUtil.showPrompt(translator.getLabel("partial_payment"), translator.getLabel("you_are_about_to_make_a_partial_payment_for_selected_items"), translator.getLabel("are_you_sure"),
                                         ()=>
                                         {
                                            this.state.showPaymentDialogue = true;
                                            this.setState({});
                                         })
        }
        else
        {
            this.state.showPaymentDialogue = true;
            this.setState({});
        }
    }

    renderPaymentDialogue()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (!this.state.showPaymentDialogue)
            return null;
        
        let partialPayableAmount = this.calculatePartialPayableAmount();
        let originallyPaidAmount = sale.paidAmount;
        
        return (
                    <PaymentDialogue
                        sale={sale}
                        partialPayableAmount = {partialPayableAmount}
                        onPaymentCompletion={async () =>
                            {
                                let newPayment = sale.paidAmount - originallyPaidAmount;
                                if (partialPayableAmount != null)
                                {
                                    let stillPayable = partialPayableAmount - newPayment;
                                    if (stillPayable <= constants.numericThresholdValue)
                                    {
                                        for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
                                        {
                                            var selectedItem = this.props.saleContext.selectedItems[index];
                                            selectedItem.isPaid = true;
                                        }
                                    }
                                }
                    
                                saleContext.selectedItems = [];
                                saleContextUtil.prepareSaleForPublishing(saleContext);
                                await saleEndorsementUtils.applySaleEndorsements(sale);
                                saleContextUtil.raiseSaleContextSaleChangeEvent(false, true, true);

                                if (newPayment > constants.numericThresholdValue && await this.isReceiptPrintingRequired()) 
                                {
                                    await salePrinter.printSaleCustomerReceipt(sale, commonUtility.getPropertyPrintConfiguration().noOfReceiptPrints);
                                }
                            }}

                        onClose={async (paymentModified) =>
                        {
                            this.state.showPaymentDialogue = false;
                            this.setState({});

                            if (paymentModified)
                            {
                                saleContext.selectedItems = [];
                                saleContextUtil.raiseSaleContextSaleChangeEvent(false, true, true);
                                if (saleCalculator.isSaleFullyPaid(sale) || saleCommonUtility.isSaleHoldByPaymentOverPhone(sale))
                                {
                                    saleContextUtil.publishAndCloseSale(saleContext);
                                }
                            }
                        }} />);
    }

    calculatePartialPayableAmount()
    {
        let saleContext = this.props.saleContext;
        let sale = saleContext.sale;

        if (saleCalculator.calculateRemainingPayableAmount(sale) <= constants.numericThresholdValue)
            return null;

        var partialPayableAmount = 0;
        for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
        {
            var selectedItem = this.props.saleContext.selectedItems[index];
            
            var totalValue = saleCalculator.calculateTotalItemPrice(selectedItem);
            if (!localizationUtils.isVatInclusive())
                totalValue = totalValue + saleCalculator.calculateTotalItemVAT(selectedItem);

            partialPayableAmount = partialPayableAmount + totalValue;
        }

        if (partialPayableAmount <= constants.numericThresholdValue ||
            partialPayableAmount > saleCalculator.calculateRemainingPayableAmount(sale))
            return null;

        return partialPayableAmount;
        
    }

    verifySelectedRowsForPayment()
    {
        for (var index = 0; index < this.props.saleContext.selectedItems.length; index++)
        {
            var selectedItem = this.props.saleContext.selectedItems[index];
            if (selectedItem.isPaid)
                return `Sale item ${selectedItem.caption} is already paid`;
        }
    }

    isReceiptPrintingRequired()
    {
        const isReceiptPrintingOptional = commonUtility.getPropertyPrintConfiguration().receiptPrintingOptional;

        if (isReceiptPrintingOptional == false) return true;

        return new Promise((resolve, reject) =>
        {
            viewUtil.showPrompt(
                "Print Receipt",
                "Do you wish to print receipt ?", null,
                () => resolve(true),        // onConfirm
                () => resolve(false));      // onDeny
        });
    }
}

const mapStateToProps = state => 
{
    return { 
                saleContext: state.saleContext,
                saleChangedDateTime: state.saleContext.saleChangedDateTime
           }
}

export default connect(mapStateToProps)(PayToolbarButton)
